import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function MumbaiToKhatuShyamCab() {



    const cardData = {





keyword: "Mumbai to Khatu Shyam Cab",

headingDescription: "Shreesha Tours & Travels offers comfortable and reliable Mumbai to Khatu Shyam Cab Service for devotees, families, and groups planning a spiritual journey to Khatu Shyam Ji Temple in Rajasthan. We provide chauffeur-driven Sedan, SUV, Ertiga, Kia Carens, Innova, Innova Crysta, Tempo Traveller, and premium vehicles for long-distance pilgrimage travel. With experienced drivers, clean vehicles, flexible travel schedules, transparent pricing, doorstep pickup, and 24/7 customer support, we ensure a safe and peaceful journey from Mumbai to Khatu Shyam. Whether you need a one-way taxi, round trip cab, or customized Rajasthan pilgrimage tour, Shreesha Tours & Travels provides convenient and comfortable travel solutions.",

topPlaces: [
  {
    title: "Khatu Shyam Ji Temple Rajasthan",
    description: "Khatu Shyam Ji Temple is one of the most famous pilgrimage destinations in Rajasthan, attracting millions of devotees every year. Dedicated to Barbarika, who is worshipped as Khatu Shyam Ji, the temple is known for its spiritual atmosphere, grand festivals, and devotional celebrations. Visitors from Mumbai travel here to seek blessings, participate in aarti, and experience the peaceful environment of this sacred temple town."
  },
  {
    title: "Salasar Balaji Temple",
    description: "Salasar Balaji Temple is a popular Hanuman temple located near Khatu Shyam and is often included in Rajasthan pilgrimage tours. The temple attracts devotees from across India who come for blessings and religious rituals. The peaceful surroundings, traditional architecture, and spiritual significance make it an important stop for travelers visiting Khatu Shyam Ji."
  },
  {
    title: "Jaipur City",
    description: "Jaipur, the Pink City of Rajasthan, is a famous tourist destination known for magnificent forts, royal palaces, colorful markets, and rich cultural heritage. Visitors can explore Amber Fort, City Palace, Hawa Mahal, Jal Mahal, and local handicraft markets. Many travelers combine Jaipur sightseeing with their Khatu Shyam pilgrimage journey for a complete Rajasthan experience."
  },
  {
    title: "Ajmer Dargah Sharif",
    description: "Ajmer is a historic city famous for Ajmer Sharif Dargah, one of India's most respected spiritual destinations. The city also offers attractions like Ana Sagar Lake, Adhai Din Ka Jhonpra, and beautiful Mughal-era architecture. Travelers often include Ajmer in their Rajasthan religious tours while visiting nearby pilgrimage locations."
  },
  {
    title: "Pushkar Lake and Brahma Temple",
    description: "Pushkar is a sacred town known for Pushkar Lake, Brahma Temple, colorful markets, and spiritual surroundings. It is one of India's oldest pilgrimage destinations and attracts visitors throughout the year. The peaceful ghats, religious ceremonies, and cultural experiences make Pushkar a memorable destination during a Rajasthan tour."
  },
  {
    title: "Neemrana Fort Palace",
    description: "Neemrana Fort Palace is a heritage destination located in Rajasthan, famous for its historic architecture, royal atmosphere, and beautiful views. The restored fort offers a unique experience with heritage stays, traditional surroundings, and cultural charm. It is a popular sightseeing stop for travelers exploring Rajasthan by road."
  },
  {
    title: "Bikaner Junagarh Fort",
    description: "Bikaner is a royal Rajasthan city known for Junagarh Fort, Lalgarh Palace, traditional markets, and famous local cuisine. The city showcases rich Rajput history, impressive architecture, and cultural traditions. Travelers visiting Khatu Shyam often extend their journey to explore Bikaner and other heritage destinations."
  },
  {
    title: "Ranthambore National Park",
    description: "Ranthambore National Park is one of India's most famous wildlife destinations, known for tiger safaris, ancient Ranthambore Fort, lakes, and diverse wildlife. Nature lovers and photographers visit this destination for unforgettable safari experiences. It can be included as an additional stop during a Rajasthan road trip from Mumbai."
  },
  {
    title: "Jodhpur Mehrangarh Fort",
    description: "Jodhpur, also known as the Blue City, is famous for Mehrangarh Fort, Umaid Bhawan Palace, Jaswant Thada, and traditional Rajasthani culture. The city offers a perfect combination of history, architecture, shopping, and local cuisine. Travelers can explore Jodhpur as part of an extended Rajasthan pilgrimage and sightseeing tour."
  },
  {
    title: "Udaipur City of Lakes",
    description: "Udaipur is one of Rajasthan's most beautiful destinations, known for Lake Pichola, City Palace, Jag Mandir, Sajjangarh Fort, and romantic landscapes. The city's royal heritage, lakes, and cultural attractions attract tourists from around the world. A Mumbai to Khatu Shyam cab journey can be customized with additional Rajasthan sightseeing destinations like Udaipur."
  }
],


"services": [
  {
    "name": "Mumbai to Khatu Shyam Cab Service",
    "description": "Book Mumbai to Khatu Shyam Cab Service for a comfortable and reliable religious journey with professional chauffeurs and well-maintained AC vehicles. Choose from Sedan, Ertiga, Innova, Innova Crysta, SUV, Kia Carens, and Tempo Traveller options for Khatu Shyam Darshan, family trips, group travel, and Rajasthan pilgrimage tours with safe and convenient travel."
  },
  {
    "name": "Khatu Shyam Cab Service from Mumbai",
    "description": "Reserve Khatu Shyam Cab Service from Mumbai for a hassle-free temple journey with experienced drivers, spacious vehicles, and flexible travel options. Enjoy doorstep pickup, comfortable seating, affordable pricing, and private cab facilities for devotees traveling from Mumbai to Khatu Shyam Mandir."
  },
  {
    "name": "Mumbai to Khatu Shyam Cab Package",
    "description": "Choose Mumbai to Khatu Shyam Cab Package for complete pilgrimage travel solutions including comfortable cab service, experienced drivers, and flexible schedules. Travel safely from Mumbai to Khatu Shyam with family and groups using premium AC vehicles with one-way and round-trip options."
  },
  {
    "name": "Mumbai to Khatu Shyamji Cab",
    "description": "Book Mumbai to Khatu Shyamji Cab for a peaceful and comfortable temple visit with reliable chauffeur-driven vehicles. Get clean AC cars, professional drivers, and convenient pickup options for Khatu Shyamji Darshan from Mumbai."
  },
  {
    "name": "Mumbai to Khatu Shyam Mandir Taxi",
    "description": "Hire Mumbai to Khatu Shyam Mandir Taxi for direct travel to the famous Khatu Shyam Temple. Enjoy smooth highway travel, experienced chauffeurs, comfortable vehicles, and affordable taxi services for devotees and families."
  },
  {
    "name": "Mumbai to Rajasthan Khatu Shyam Cab",
    "description": "Book Mumbai to Rajasthan Khatu Shyam Cab for a comfortable long-distance pilgrimage journey. Travel with trusted drivers and premium vehicles suitable for Khatu Shyam Darshan, Rajasthan tours, and family religious trips."
  },
  {
    "name": "Mumbai to Sikar Cab Service",
    "description": "Reserve Mumbai to Sikar Cab Service for safe and convenient Rajasthan travel with professional drivers. Enjoy comfortable AC cabs for business trips, temple visits, family tours, and outstation journeys from Mumbai to Sikar."
  },
  {
    "name": "Mumbai to Khatu Shyam Darshan Cab",
    "description": "Book Mumbai to Khatu Shyam Darshan Cab for a dedicated pilgrimage taxi service with flexible timings and private travel options. Enjoy doorstep pickup, comfortable seating, and reliable transportation for a peaceful temple journey."
  },
  {
    "name": "Mumbai to Khatu Shyam Road Trip Taxi",
    "description": "Choose Mumbai to Khatu Shyam Road Trip Taxi for a memorable road journey with experienced chauffeurs and comfortable vehicles. Travel conveniently with family and friends in spacious AC cars designed for long-distance travel."
  },
  {
    "name": "Mumbai to Khatu Shyam Long Distance Cab",
    "description": "Hire Mumbai to Khatu Shyam Long Distance Cab for safe interstate travel with professional drivers and well-maintained vehicles. Get reliable long-route taxi service with flexible booking options and comfortable rides."
  },
  {
    "name": "Mumbai to Khatu Shyam Round Trip Cab",
    "description": "Book Mumbai to Khatu Shyam Round Trip Cab for complete return journey solutions with flexible schedules. Enjoy comfortable travel, experienced chauffeurs, and affordable round-trip cab packages for temple darshan."
  },
  {
    "name": "Mumbai to Khatu Shyam Pickup and Drop",
    "description": "Reserve Mumbai to Khatu Shyam Pickup and Drop service for convenient doorstep transportation. Get timely pickup, direct drop, professional drivers, and comfortable AC vehicles for your religious journey."
  },
  {
    "name": "Mumbai to Khatu Shyam AC Cab",
    "description": "Choose Mumbai to Khatu Shyam AC Cab for a comfortable and climate-controlled journey. Travel safely with clean vehicles, skilled chauffeurs, and premium cab facilities for long-distance pilgrimage travel."
  },
  {
    "name": "Mumbai to Khatu Shyam SUV Cab",
    "description": "Book Mumbai to Khatu Shyam SUV Cab for spacious and comfortable travel with extra luggage capacity. Ideal for families and groups looking for a smooth Rajasthan journey with professional drivers."
  },
  {
    "name": "Mumbai to Khatu Shyam Innova Crysta Cab",
    "description": "Hire Mumbai to Khatu Shyam Innova Crysta Cab for premium long-distance travel with luxury interiors and spacious seating. Enjoy a comfortable pilgrimage journey with experienced chauffeurs and superior ride quality."
  },
  {
    "name": "Mumbai to Khatu Shyam Tempo Traveller",
    "description": "Book Mumbai to Khatu Shyam Tempo Traveller for group pilgrimage tours with comfortable seating and spacious interiors. Perfect for families, groups, and devotees traveling together for Khatu Shyam Darshan."
  },
  {
    "name": "Mumbai to Khatu Shyam Family Cab Service",
    "description": "Choose Mumbai to Khatu Shyam Family Cab Service for safe and comfortable family travel. Get reliable vehicles, experienced drivers, and convenient travel options for elderly passengers and family groups."
  },
  {
    "name": "Mumbai to Khatu Shyam Corporate Cab",
    "description": "Reserve Mumbai to Khatu Shyam Corporate Cab for organized group transportation with professional service. Suitable for corporate groups, employee travel, and planned Rajasthan trips from Mumbai."
  },
  {
    "name": "Mumbai to Khatu Shyam Outstation Roundtrip Cabs",
    "description": "Book Mumbai to Khatu Shyam Outstation Roundtrip Cabs for complete return travel with flexible schedules. Enjoy private cabs, experienced drivers, comfortable vehicles, and reliable long-distance service."
  },
  {
    "name": "Mumbai to Rajasthan Cab",
    "description": "Book Mumbai to Rajasthan Cab for comfortable outstation travel with professional chauffeurs and premium vehicles. Choose from Sedan, SUV, Innova, Ertiga, Innova Crysta, and luxury cabs for Rajasthan tours."
  },
  {
    "name": "Mumbai to Rajasthan Taxi",
    "description": "Choose Mumbai to Rajasthan Taxi for reliable interstate transportation with affordable fares and experienced drivers. Enjoy smooth travel for family trips, business journeys, and Rajasthan sightseeing tours."
  },
  {
    "name": "Mumbai to Rajasthan Cab Service",
    "description": "Reserve Mumbai to Rajasthan Cab Service for safe and comfortable long-distance travel. Get doorstep pickup, clean AC vehicles, professional chauffeurs, and flexible one-way or round-trip booking options."
  },
  {
    "name": "Mumbai to Rajasthan Taxi Booking",
    "description": "Complete Mumbai to Rajasthan Taxi Booking online for quick confirmation and hassle-free travel. Select your preferred vehicle category and enjoy reliable chauffeur-driven taxi services."
  },
  {
    "name": "Cab from Mumbai to Rajasthan",
    "description": "Hire Cab from Mumbai to Rajasthan for private and comfortable travel across states. Enjoy experienced drivers, spacious vehicles, affordable pricing, and smooth highway journeys."
  },
  {
    "name": "Taxi from Mumbai to Rajasthan",
    "description": "Book Taxi from Mumbai to Rajasthan for convenient long-distance transportation. Travel safely with professional chauffeurs and well-maintained vehicles for personal and family trips."
  },
  {
    "name": "Mumbai to Rajasthan Car Rental",
    "description": "Choose Mumbai to Rajasthan Car Rental for chauffeur-driven cars with flexible travel options. Get reliable vehicles for Rajasthan tourism, pilgrimage tours, corporate travel, and family vacations."
  },
  {
    "name": "Mumbai to Rajasthan One Way Cab",
    "description": "Book Mumbai to Rajasthan One Way Cab for economical drop taxi service without return charges. Enjoy comfortable travel with professional drivers and multiple vehicle options."
  },
  {
    "name": "Mumbai to Rajasthan Drop Taxi",
    "description": "Reserve Mumbai to Rajasthan Drop Taxi for affordable one-way interstate travel. Get direct pickup and drop service with comfortable AC vehicles and experienced chauffeurs."
  },
  {
    "name": "Mumbai to Rajasthan Outstation Cab",
    "description": "Hire Mumbai to Rajasthan Outstation Cab for reliable long-distance journeys with premium vehicles. Perfect for tourism, family trips, religious tours, and business travel requirements."
  },
  {
    "name": "Mumbai to Jaipur Cab",
    "description": "Book Mumbai to Jaipur Cab for comfortable Rajasthan travel with experienced drivers and clean AC vehicles. Enjoy reliable transportation for sightseeing, business trips, and family vacations."
  },
  {
    "name": "Mumbai to Jodhpur Cab",
    "description": "Choose Mumbai to Jodhpur Cab for smooth and safe travel with professional chauffeurs. Get comfortable vehicles for Rajasthan sightseeing and long-distance journeys."
  },
  {
    "name": "Mumbai to Udaipur Cab",
    "description": "Reserve Mumbai to Udaipur Cab for convenient travel to the city of lakes. Enjoy premium cab facilities, experienced drivers, and comfortable vehicles for tourism and family trips."
  },
  {
    "name": "Mumbai to Ajmer Cab",
    "description": "Book Mumbai to Ajmer Cab for reliable travel with comfortable vehicles and professional chauffeurs. Suitable for religious visits, family tours, and Rajasthan travel."
  },
  {
    "name": "Mumbai to Bikaner Cab",
    "description": "Hire Mumbai to Bikaner Cab for safe and comfortable interstate travel. Enjoy spacious vehicles, affordable pricing, and experienced drivers for long-distance journeys."
  },
  {
    "name": "Mumbai to Pushkar Cab",
    "description": "Choose Mumbai to Pushkar Cab for convenient pilgrimage and tourism travel. Get reliable chauffeur-driven cabs for Pushkar visits, family trips, and Rajasthan exploration."
  },
  {
    "name": "Mumbai to Mount Abu Cab",
    "description": "Book Mumbai to Mount Abu Cab for a comfortable hill station journey with professional drivers. Travel safely with premium vehicles suitable for family vacations and sightseeing."
  },
  {
    "name": "Mumbai to Sikar Cab",
    "description": "Reserve Mumbai to Sikar Cab for affordable and reliable travel with clean vehicles and experienced chauffeurs. Perfect for Khatu Shyam visits and Rajasthan trips."
  },
  {
    "name": "Mumbai to Rajasthan Tour Cab",
    "description": "Book Mumbai to Rajasthan Tour Cab for customized Rajasthan sightseeing packages. Enjoy flexible routes, comfortable vehicles, professional drivers, and private travel for exploring Rajasthan destinations."
  }
],
"tableData": [
  ["Mumbai to Khatu Shyam Cab Service", "Khatu Shyam Cab Service from Mumbai"],
  ["Mumbai to Khatu Shyam Cab Package", "Mumbai to Khatu Shyamji Cab"],
  ["Mumbai to Khatu Shyam Mandir Taxi", "Mumbai to Rajasthan Khatu Shyam Cab"],
  ["Mumbai to Sikar Cab Service", "Mumbai to Khatu Shyam Darshan Cab"],
  ["Mumbai to Khatu Shyam Road Trip Taxi", "Mumbai to Khatu Shyam Long Distance Cab"],
  ["Mumbai to Khatu Shyam Round Trip Cab", "Mumbai to Khatu Shyam Pickup and Drop"],
  ["Mumbai to Khatu Shyam AC Cab", "Mumbai to Khatu Shyam SUV Cab"],
  ["Mumbai to Khatu Shyam Innova Crysta Cab", "Mumbai to Khatu Shyam Tempo Traveller"],
  ["Mumbai to Khatu Shyam Family Cab Service", "Mumbai to Khatu Shyam Corporate Cab"],
  ["Mumbai to Khatu Shyam Outstation Roundtrip Cabs", "Mumbai to Rajasthan Cab"],
  ["Mumbai to Rajasthan Taxi", "Mumbai to Rajasthan Cab Service"],
  ["Mumbai to Rajasthan Taxi Booking", "Cab from Mumbai to Rajasthan"],
  ["Taxi from Mumbai to Rajasthan", "Mumbai to Rajasthan Car Rental"],
  ["Mumbai to Rajasthan One Way Cab", "Mumbai to Rajasthan Drop Taxi"],
  ["Mumbai to Rajasthan Outstation Cab", "Mumbai to Jaipur Cab"],
  ["Mumbai to Jodhpur Cab", "Mumbai to Udaipur Cab"],
  ["Mumbai to Ajmer Cab", "Mumbai to Bikaner Cab"],
  ["Mumbai to Pushkar Cab", "Mumbai to Mount Abu Cab"],
  ["Mumbai to Sikar Cab", "Mumbai to Rajasthan Tour Cab"]
],



whychoose: [
  {
    WhyChooseheading: "Comfortable Mumbai to Khatu Shyam Cab Service",
    WhyChoosedescription: "Shreesha Travels provides reliable Mumbai to Khatu Shyam cab services for devotees, families, and groups planning a spiritual journey. Travel comfortably from Mumbai to Khatu Shyam Ji Temple with experienced chauffeurs and well-maintained vehicles."
  },
  {
    WhyChooseheading: "Direct Door-to-Door Temple Travel",
    WhyChoosedescription: "Enjoy convenient pickup from your home, office, hotel, or preferred location in Mumbai and get direct drop service at Khatu Shyam Ji Temple or nearby locations without changing multiple transport options."
  },
  {
    WhyChooseheading: "Spacious Vehicles for Long-Distance Yatra",
    WhyChoosedescription: "Choose from Sedan Cars, Swift Dzire, Toyota Etios, Ertiga, Kia Carens, Innova, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles suitable for families, devotees, and groups."
  },
  {
    WhyChooseheading: "Ideal for Religious Tours & Family Trips",
    WhyChoosedescription: "Our Mumbai to Khatu Shyam taxi service is perfect for temple darshan, pilgrimage tours, family journeys, senior citizen travel, and customized Rajasthan religious trips."
  },
  {
    WhyChooseheading: "One-Way & Round Trip Cab Options",
    WhyChoosedescription: "Book a one-way cab to Khatu Shyam or choose a round-trip package with flexible return schedules, waiting options, and customized travel plans according to your requirements."
  },
  {
    WhyChooseheading: "Experienced Drivers for Rajasthan Routes",
    WhyChoosedescription: "Our professional chauffeurs have experience with long-distance highway travel and Rajasthan routes, ensuring safe driving, timely service, and a comfortable journey."
  },
  {
    WhyChooseheading: "Clean & Comfortable Cars for Pilgrimage",
    WhyChoosedescription: "Every vehicle is regularly serviced, sanitized, air-conditioned, and inspected before every trip to provide devotees with a peaceful and relaxing travel experience."
  },
  {
    WhyChooseheading: "Book Mumbai to Khatu Shyam Cab with Shreesha Travels",
    WhyChoosedescription: "Get transparent pricing, quick booking assistance, professional chauffeur service, and dependable transportation for your Khatu Shyam Ji pilgrimage from Mumbai."
  }
]

};

const faqData = [
  {
    question: "Can I book a cab from Mumbai to Khatu Shyam Ji Temple?",
    answer: "Yes, you can book a private cab from Mumbai to Khatu Shyam Ji Temple for a comfortable and direct pilgrimage journey."
  },
  {
    question: "Do you provide one-way taxi service from Mumbai to Khatu Shyam?",
    answer: "Yes, one-way cab services are available for passengers travelling directly to Khatu Shyam."
  },
  {
    question: "Can I book a round-trip cab for Khatu Shyam Darshan?",
    answer: "Yes, round-trip taxi packages are available with flexible return timing and customized travel schedules."
  },
  {
    question: "Which vehicles are available for Mumbai to Khatu Shyam travel?",
    answer: "We provide Sedan Cars, Swift Dzire, Toyota Etios, Ertiga, Kia Carens, Innova, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles."
  },
  {
    question: "Is this cab service suitable for senior citizens?",
    answer: "Yes, our comfortable vehicles and experienced chauffeurs make the journey convenient for senior citizens and families."
  },
  {
    question: "Can I include sightseeing places during the trip?",
    answer: "Yes, customized itineraries with sightseeing stops and nearby destinations can be arranged according to your travel plan."
  },
  {
    question: "How many days are required for Mumbai to Khatu Shyam trip?",
    answer: "The travel duration depends on the route, stay requirements, darshan schedule, and selected trip plan."
  },
  {
    question: "How is the Mumbai to Khatu Shyam cab fare calculated?",
    answer: "The fare depends on the vehicle type, travel distance, trip duration, toll charges, parking fees, driver allowance, and additional requirements."
  },
  {
    question: "Are overnight journeys available for Khatu Shyam Yatra?",
    answer: "Yes, overnight travel options are available according to your preferred departure time and pilgrimage schedule."
  },
  {
    question: "How can I book Mumbai to Khatu Shyam Cab with Shreesha Travels?",
    answer: "Share your travel date, pickup location, passenger count, preferred vehicle, and trip type to receive a customized quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rajesh Agarwal",
    feedback: "Our Mumbai to Khatu Shyam journey was very comfortable. The driver was experienced, the vehicle was clean, and the complete pilgrimage trip was managed smoothly.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Kavita Sharma",
    feedback: "Excellent cab service for Khatu Shyam Darshan. The car was spacious, the chauffeur was polite, and our family had a safe and peaceful journey.",
    rating: 5
  }
];






    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
        { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Nashik Cab", link: "Mumbai-to-Nashik-Cab" },
        { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
        { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
        { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
        { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
        { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
        { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
        { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
        { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
        { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
        { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
        { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
        { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
        { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
        { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
    ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Khatu Shyam Cab",
  "image": "https://www.shreeshatravels.com/assets/images/mumbai-to-khatu-shyam-cab.webp",
  "description":
    "Book Mumbai to Khatu Shyam Cab with Shreesha Tours & Travels for comfortable and reliable pilgrimage taxi services. We provide Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7 for Khatu Shyam Ji Darshan, Rajasthan religious tours, family trips, temple visits, one-way, round-trip, and long-distance journeys from Mumbai with experienced drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Shreesha Tours & Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shreeshatravels.com/mumbai-to-khatu-shyam-cab"
  }
};




    return (
        <div>
<Helmet>
  <title>Mumbai to Khatu Shyam Cab | Khatu Shyam Ji Darshan Taxi | +91 8355835813</title>

  <meta
    name="description"
    content="Book Mumbai to Khatu Shyam Cab with Shreesha Travels for safe and comfortable pilgrimage taxi services. Hire Sedan, Ertiga, SUV, Innova, and Innova Crysta for Khatu Shyam Ji Darshan, Rajasthan temple tours, family trips, one-way travel, round trips, and 24x7 cab booking."
  />

  <meta
    name="keywords"
    content="Mumbai to Khatu Shyam Cab Service, Khatu Shyam Cab Service from Mumbai, Mumbai to Khatu Shyam Cab Package, Mumbai to Khatu Shyamji Cab, Mumbai to Khatu Shyam Mandir Taxi, Mumbai to Rajasthan Khatu Shyam Cab, Mumbai Khatu Shyam Taxi, Khatu Shyam Darshan Cab Mumbai, Khatu Shyam Yatra Package from Mumbai, Rajasthan Religious Tour Taxi Mumbai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/109.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Shreesha Tours & Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Shreesha Tours & Travels</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shreesha Tours & Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918355835813 " className="pc-call">+91 8355835813 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919930929439 " className="pc-call">+91 9930929439 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919022432779 " className="pc-call">+91 9022432779 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91919930929439 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918355835813 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@shreeshatravels.com" className="pc-email">
                                            booking@shreeshatravels.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Shreesha Tours & Travels</strong><br />
                                            Office 125, Saishraddha CHS,
                                            Plot No 47, Near Koparkhairane Police Station,
                                            Sector 5, Sector 4,Ghansoli, Navi Mumbai,
                                            Maharashtra, India- 400701




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default MumbaiToKhatuShyamCab;